import { MultiCombobox, type MultiComboboxProps } from './multi-combobox';
import { SingleCombobox, type SingleComboboxProps } from './single-combobox';

// The discriminant lives here rather than on the presets, which know nothing about this union. It is mandatory on
// the multi arm: optional, array-shaped props would match it while the dispatch below fell through to single-select.
export type ComboboxProps<T> =
  | (MultiComboboxProps<T> & { multiple: true })
  | (SingleComboboxProps<T> & { multiple?: false });

export const Combobox = <T,>(props: ComboboxProps<T>) => {
  return props.multiple ? (
    <MultiCombobox {...(props as MultiComboboxProps<T>)} />
  ) : (
    <SingleCombobox {...(props as SingleComboboxProps<T>)} />
  );
};
